import {
	Component,
	OnInit,
	ChangeDetectionStrategy,
	TestabilityRegistry,
	ChangeDetectorRef
} from "@angular/core";
import { Router } from "@angular/router";
import { GlobalService } from "../../../services/global/global.service";
import { Observable } from "rxjs";
import { DMVStoreService } from "../../../services/dmv/dmv-store.service";
import { DMVDataService } from "../../../services/dmv/dmv-data.service";
import { RegistrationRequest } from "src/app/models/dmv/registration.request";
import { AgencyDmvConfigResponse } from "src/app/models/dmv/agency-config.response";
import { DmvCostDataRequest } from "src/app/models/dmv/dmv-cost-data.request";
import { RegistrationResponse } from "src/app/models/dmv/registration.response";

import { TagCatalog } from "src/app/models/dmv/tagCatalog";
import { RouteFrom } from "../../../models/routeFrom";
import { Registration } from "src/app/models/dmv/registration";
import { AppUtil } from "../../../utils/app.util";
import { DmvCostData, DmvFee } from "src/app/models/dmv/models";

@Component({
	selector: "dmv-customize-order",
	templateUrl: "./customize-order.component.html",
	styleUrls: ["./customize-order.component.css"],
	changeDetection: ChangeDetectionStrategy.Default
})
export class CustomizeOrderComponent implements OnInit {
	constructor(
		private router: Router,
		public globalService: GlobalService,
		public dmvStoreService: DMVStoreService,
		public dmvDataService: DMVDataService,
		private cd: ChangeDetectorRef
	) {}
	public addUpdateInsurance: boolean = false;
	public openConfirmModel: boolean = false;
	public changePlatePopUpOpen: boolean = false;
	public totalCostAmmount: number = 0;
	public renewalOption: number;
	public registrationNumber: number;
	public lastRegistrationNumber: number;
	public errorMessage: string = "";
	public isloading: boolean = false;
	public hasTagCatalogData: boolean = false;
	public agencyConfig: AgencyDmvConfigResponse;
	public registrationData: Array<Registration>;
	public isHideForPlate: boolean;
	public isHideForRenewal: boolean;
	public tagCatalog: TagCatalog;
	public plateChangeData: any;
	public dmvCost: DmvCostData;
	public plateData: any;
	ngOnInit() {
		this.plateData = null;
		this.dmvCost = null;
		this.isHideForPlate = false;
		this.isHideForRenewal = false;
		AppUtil.log("CustomizeOrderComponent ngOnInit()");
		if (
			this.dmvStoreService.routeFrom &&
			this.dmvStoreService.routeFrom.orderNumber
		) {
			this.registrationNumber = this.dmvStoreService.routeFrom.orderNumber;
		} else {
			this.registrationNumber = 0;
		}

		this.dmvStoreService.agencyConfig$
			.subscribe(agencyConfig => {
				if (agencyConfig) {
					this.agencyConfig = agencyConfig;
				}
			})
			.unsubscribe();

		// this.dmvStoreService.registrationData$.subscribe(data => {
		// 	if (data) {
		this.registrationData = this.dmvStoreService.registrationsInCart.selectedRegistrations;
		// 	}
		// });

		this.dmvStoreService.tagCatalogData$.subscribe(tagCatalogResponse => {
			if (tagCatalogResponse) {
				this.tagCatalog = tagCatalogResponse.tagCatalog;
			}
		});
	}
	public moveToRegistration(event) {
		AppUtil.log(
			"CustomizeOrderComponent moveToRegistration() ==> registrationNumber ==",
			this.registrationNumber
		);
		if (this.registrationNumber === event) {
			this.dmvStoreService.routeFrom = Object.create(null);
		} else {
			this.lastRegistrationNumber = this.registrationNumber;
			this.registrationNumber = event;
			this.globalService.routerLastUrl = this.globalService.routerCurrentUrl;
		}
	}

	public getImageCode(currentTagCode) {
		AppUtil.log(
			"CustomizeOrderComponent getImageCode() ==> currentTagCode ==",
			currentTagCode
		);
		if (currentTagCode && this.tagCatalog) {
			const tags = this.tagCatalog.filter(function(item) {
				return item.tagCode === currentTagCode;
			});
			if (tags && tags.length > 0) {
				return tags[0];
			}
		}
		return null;
	}

	public goBack() {
		// if (this.isHideForPlate) {
		// 	this.registrationData.forEach(registration => {
		// 		if (
		// 			registration.registrationID ===
		// 			this.dmvStoreService.registrationsInCart.dmvRegistrations[
		// 				this.registrationNumber
		// 			].registration.registrationID
		// 		) {
		// 			this.dmvStoreService.registrationsInCart.dmvRegistrations[
		// 				this.registrationNumber
		// 			].registration.currentTagCode =
		// 				registration.currentTagCode;

		// 			const image = this.getImageCode(registration.currentTagCode);
		// 			this.dmvStoreService.registrationsInCart.dmvRegistrations[
		// 				this.registrationNumber
		// 			].imageCode = image ? image.imageCode : null;

		// 			this.dmvStoreService.registrationsInCart.dmvRegistrations[
		// 				this.registrationNumber
		// 			].altText = image ? image.name : null;
		// 		}
		// 	});
		// }

		AppUtil.log(
			"CustomizeOrderComponent goBack() ==> this.dmvStoreService.routeFrom ==> ",
			this.dmvStoreService.routeFrom
		);

		this.isHideForPlate = false;
		this.isHideForRenewal = false;

		this.errorMessage = "";
		if (
			this.dmvStoreService.routeFrom &&
			this.dmvStoreService.routeFrom.from === "dmv-review-cart"
		) {
			this.router.navigate([this.dmvStoreService.routeFrom.from], {
				skipLocationChange: true
			});
		} else if (
			this.dmvStoreService.routeFrom &&
			this.dmvStoreService.routeFrom.from === "shoping-cart"
		) {
			this.dmvStoreService.routeFrom = Object.create(null);
			this.router.navigate(
				[this.globalService.routerLastUrl.replace("/", "")],
				{
					skipLocationChange: true
				}
			);
			this.registrationNumber = this.lastRegistrationNumber;
		} else {
			if (this.registrationNumber !== 0) {
				this.registrationNumber = this.registrationNumber - 1;
			} else {
				this.router.navigate(["dmv-search-results"], {
					skipLocationChange: true
				});
			}
		}
	}
	public setRenewalOption(option) {
		// this.renewalOption = option.target.value - 1;
		// this.dmvStoreService.registrationsInCart.dmvRegistrations[
		// 	this.registrationNumber
		// ].selectedRenewalOption =
		// 	option.target.value;
		this.updateRenewalOption(option.target.value);
	}
	public addUpdateInsuranceInfo() {
		this.addUpdateInsurance = true;
	}
	public closeAddUpdateInsurance() {
		this.addUpdateInsurance = false;
	}

	public showMailFee(dmvFee) {
		if (dmvFee.feeID === 1) {
			if (this.agencyConfig.agencyDmvConfig.mailFeeModel !== "NEVER") {
				if (this.agencyConfig.agencyDmvConfig.mailFeeModel === "ALWAYS") {
					return true;
				} else if (
					this.agencyConfig.agencyDmvConfig.mailFeeModel === "MAILONLY" &&
					this.dmvStoreService.registrationsInCart.mailingAddress
				) {
					return false;
				} else {
					return false;
				}
			}
		} else {
			return true;
		}
	}
	public isOptionSelected(
		itemValue: number,
		selectedOption: number,
		registrationNum: number
	) {
		if (
			itemValue === selectedOption &&
			this.registrationNumber === registrationNum
		) {
			return true;
		} else {
			return false;
		}
	}

	public updateInsurance(event) {
		AppUtil.log("CustomizeOrderComponent updateInsurance() ==> event", event);

		if (!this.isHideForRenewal && !this.isHideForPlate) {
			this.errorMessage = "";
		}

		this.addUpdateInsurance = false;
		this.dmvStoreService.registrationsInCart.dmvRegistrations[
			this.registrationNumber
		].globalInsuranceData =
			event.insuranceData;
	}

	public isPlatePersonalized(imageCode) {
		return imageCode && imageCode.slice(-1) === "P";
	}
	public isPlateAmateur(imageCode) {
		return imageCode && imageCode.slice(-1) === "A";
	}
	public findDmvCost(request, agencyID, registrationID, data, type) {
		AppUtil.log(
			"CustomizeOrderComponent findDmvCost() ==>",
			request,
			agencyID,
			registrationID,
			data,
			type
		);
		this.dmvDataService
			.getDmvCostResponse(
				request.newTagCode,
				request.renewalOptionID,
				agencyID,
				registrationID,
				this.dmvStoreService.sessionID
			)
			.subscribe(
				response => {
					AppUtil.log("CustomizeOrderComponent findDmvCost() ==>", response);

					if (response) {
						this.isloading = false;
						if (response.statusCode === 202) {
							this.errorMessage =
								this.dmvStoreService.agencyConfig.agencyDmvConfig
									.systemFailureText +
								" (EC:CO" +
								response.OutcomeCode +
								")";
							if (data && type === "updateRenewalOption") {
								this.isHideForRenewal = true;
							} else if (data && type === "tag") {
								this.isHideForPlate = true;
							}
							this.changePlatePopUpOpen = false;
							window.scrollTo(0, 0);
						} else {
							if (data && type === "updateRenewalOption") {
								this.isHideForRenewal = false;
								const renewalOption = data;
								this.renewalOption = renewalOption - 1;
								this.dmvStoreService.registrationsInCart.dmvRegistrations[
									this.registrationNumber
								].selectedRenewalOption = Number(renewalOption);
								this.updateDmvCost(response.dmvCostData);
							} else if (data && type === "tag") {
								this.isHideForPlate = false;
								const tag = data;

								this.dmvCost = response.dmvCostData;
								if (response.dmvCostData) {
									const registration = this.getFirstResistration();

									if (
										tag.tagCode === undefined ||
										tag.tagCode === registration[0].currentTagCode
									) {
										this.changePlatePopUpOpen = false;
										this.dmvStoreService.registrationsInCart.dmvRegistrations[
											this.registrationNumber
										].isPlateChange = false;
										this.updateDmvCost(response.dmvCostData);
									}
									this.updateNewPlateDataForPopup(response.dmvCostData, tag);
									//this.updateNewDmvCostAndTagData(response.dmvCostData, tag);
								}
							}
							if (!this.isHideForRenewal && !this.isHideForPlate) {
								this.errorMessage = null;
							}
						}

						this.cd.markForCheck();
					}
				},
				error => {
					if (
						error.name === "HttpErrorResponse" ||
						error.name === "TimeoutError" ||
						(error["status"] && error["status"] !== 200)
					) {
						this.changePlatePopUpOpen = false;
						this.errorMessage = this.dmvStoreService.agencyConfig.agencyDmvConfig.systemFailureText;
						this.isloading = false;
						window.scrollTo(0, 0);
						this.cd.markForCheck();
					}
				}
			);
	}

	public updateNewPlateDataForPopup(dmvCostData: DmvCostData, tag) {
		AppUtil.log(
			"CustomizeOrderComponent updateNewPlateDataForPopup ====>",
			dmvCostData
		);

		const newImageCode = tag.imageCode;
		const newAltText = tag.name;
		let plateStyleNetChange = 0;
		let plateStyleProcessingCost = 0;
		let plateStyleRepLacementFee = 0;
		if (dmvCostData && dmvCostData.dmvFees) {
			dmvCostData.dmvFees.forEach(dmvFee => {
				if (dmvFee.feeID === 4) {
					plateStyleRepLacementFee = dmvFee.amount;
				}
				if (dmvFee.feeID === 7) {
					plateStyleNetChange = dmvFee.amount;
				}
				if (dmvFee.feeID === 8) {
					plateStyleProcessingCost = dmvFee.amount;
				}
			});
		}
		const newPlateStyleCost =
			plateStyleNetChange + plateStyleRepLacementFee + plateStyleProcessingCost;

		this.plateData = {
			newImageCode: newImageCode,
			newAltText: newAltText,
			plateStyleNetChange: plateStyleNetChange,
			plateStyleProcessingCost: plateStyleProcessingCost,
			plateStyleRepLacementFee: plateStyleRepLacementFee,
			newPlateStyleCost: newPlateStyleCost
		};
	}

	public updateNewDmvCostAndTagData(dmvCostData: DmvCostData, tag) {
		AppUtil.log(
			"CustomizeOrderComponent updateNewDmvCostAndTagData ====>",
			dmvCostData
		);
		this.dmvStoreService.registrationsInCart.dmvRegistrations[
			this.registrationNumber
		].newImageCode =
			tag.imageCode;
		this.dmvStoreService.registrationsInCart.dmvRegistrations[
			this.registrationNumber
		].newAltText =
			tag.name;
		let plateStyleNetChange = 0;
		let plateStyleProcessingCost = 0;
		let plateStyleRepLacementFee = 0;
		if (dmvCostData && dmvCostData.dmvFees) {
			dmvCostData.dmvFees.forEach(dmvFee => {
				if (dmvFee.feeID === 4) {
					plateStyleRepLacementFee = dmvFee.amount;
				}
				if (dmvFee.feeID === 7) {
					plateStyleNetChange = dmvFee.amount;
				}
				if (dmvFee.feeID === 8) {
					plateStyleProcessingCost = dmvFee.amount;
				}
			});
		}
		const newPlateStyleCost =
			plateStyleNetChange + plateStyleRepLacementFee + plateStyleProcessingCost;

		this.dmvStoreService.registrationsInCart.dmvRegistrations[
			this.registrationNumber
		].plateStyleProcessingCost = plateStyleProcessingCost;

		this.dmvStoreService.registrationsInCart.dmvRegistrations[
			this.registrationNumber
		].plateStyleRepLacementFee = plateStyleRepLacementFee;

		this.dmvStoreService.registrationsInCart.dmvRegistrations[
			this.registrationNumber
		].plateStyleNetChange = plateStyleNetChange;

		this.dmvStoreService.registrationsInCart.dmvRegistrations[
			this.registrationNumber
		].newPlateStyleCost = newPlateStyleCost;
		// this.dmvStoreService.registrationsInCart.dmvRegistrations = this.dmvStoreService.registrationsInCart.dmvRegistrations.slice();
	}
	public updateDmvCost(dmvCostData) {
		AppUtil.log("CustomizeOrderComponent updateDmvCost ====>", dmvCostData);
		this.dmvStoreService.registrationsInCart.dmvRegistrations[
			this.registrationNumber
		].registration.dmvFees =
			dmvCostData.dmvFees;
		this.dmvStoreService.registrationsInCart.dmvRegistrations[
			this.registrationNumber
		].registration.totalAmountDue =
			dmvCostData.totalAmountDue;
		this.dmvStoreService.registrationsInCart.dmvRegistrations[
			this.registrationNumber
		].registration.renewalCost =
			dmvCostData.renewalCost;
		this.dmvStoreService.registrationsInCart.dmvRegistrations = this.dmvStoreService.registrationsInCart.dmvRegistrations.slice();
	}
	public updateRenewalOption(renewalOption) {
		AppUtil.log(
			"CustomizeOrderComponent updateRenewalOption ====>",
			renewalOption
		);
		const dmvCostDataRequest: DmvCostDataRequest = new DmvCostDataRequest();
		const agencyID = this.agencyConfig.agencyDmvConfig.agencyID;
		dmvCostDataRequest.renewalOptionID = renewalOption;
		if (
			this.dmvStoreService.registrationsInCart.dmvRegistrations[
				this.registrationNumber
			].isPlateChange
		) {
			dmvCostDataRequest.newTagCode = this.dmvStoreService.registrationsInCart.dmvRegistrations[
				this.registrationNumber
			].registration.currentTagCode;
		}

		const registrationID = this.dmvStoreService.registrationsInCart
			.dmvRegistrations[this.registrationNumber].registration.registrationID;

		this.isloading = true;

		this.findDmvCost(
			dmvCostDataRequest,
			agencyID,
			registrationID,
			renewalOption,
			"updateRenewalOption"
		);
	}

	public continue() {
		//need to work
		AppUtil.log("CustomizeOrderComponent continue()");
		// if allowPlateChange = true then verify if it change or not
		this.errorMessage = "";
		if (
			(!this.dmvStoreService.registrationsInCart.dmvRegistrations[
				this.registrationNumber
			].registration.availableRenewalOptions ||
				(this.dmvStoreService.registrationsInCart.dmvRegistrations[
					this.registrationNumber
				].registration.availableRenewalOptions &&
					this.dmvStoreService.registrationsInCart.dmvRegistrations[
						this.registrationNumber
					].registration.availableRenewalOptions.length === 0)) &&
			this.dmvStoreService.registrationsInCart.dmvRegistrations[
				this.registrationNumber
			].registration.allowPlateChange
		) {
			let currentTagCode = "";
			this.registrationData.forEach(registration => {
				if (
					registration.registrationID ===
					this.dmvStoreService.registrationsInCart.dmvRegistrations[
						this.registrationNumber
					].registration.registrationID
				) {
					currentTagCode = registration.currentTagCode;
				}
			});

			if (
				this.dmvStoreService.registrationsInCart.dmvRegistrations[
					this.registrationNumber
				].registration.currentTagCode === currentTagCode
			) {
				this.openConfirmModel = true;
				return;
			}
		}
		if (
			this.dmvStoreService.registrationsInCart.dmvRegistrations[
				this.registrationNumber
			].registration.promptForInsurance &&
			!this.dmvStoreService.registrationsInCart.dmvRegistrations[
				this.registrationNumber
			].globalInsuranceData
		) {
			this.errorMessage =
				"Please provide insurance information before continuing.";
			window.scrollTo(0, 0);
			return;
		}
		if (
			this.dmvStoreService.routeFrom &&
			this.dmvStoreService.routeFrom.from === "dmv-review-cart"
		) {
			this.router.navigate(["dmv-review-cart"], { skipLocationChange: true });
		} else if (
			this.dmvStoreService.routeFrom &&
			this.dmvStoreService.routeFrom.from === "shoping-cart"
		) {
			this.dmvStoreService.routeFrom = Object.create(null);
			if (this.globalService.routerLastUrl === "/dmv-search") {
				this.router.navigate(["dmv-review-cart"], { skipLocationChange: true });
			} else {
				this.router.navigate(
					[this.globalService.routerLastUrl.replace("/", "")],
					{
						skipLocationChange: true
					}
				);
			}
			this.registrationNumber = this.lastRegistrationNumber;
		} else {
			if (
				this.dmvStoreService.registrationsInCart.dmvRegistrations.length !==
				this.registrationNumber + 1
			) {
				this.registrationNumber = 1 + this.registrationNumber;
			} else {
				if (this.dmvStoreService.registrationsInCart.firstIteration) {
					this.router.navigate(["dmv-donation"], { skipLocationChange: true });
				} else if (this.dmvStoreService.addressrequired) {
					this.dmvStoreService.registrationsInCart.mailingAddress = null;
					if (this.agencyConfig.agencyDmvConfig.allowPickup) {
						this.router.navigate(["dmv-pickup-method"], {
							skipLocationChange: true
						});
					} else if (
						this.agencyConfig.agencyDmvConfig.allowAddressUpdate ||
						this.agencyConfig.agencyDmvConfig.allowMailingToTempAddress
					) {
						this.router.navigate(["dmv-pickup-mailing"], {
							skipLocationChange: true
						});
					} else {
						this.dmvStoreService.updateAddress();
						this.router.navigate(["dmv-review-cart"], {
							skipLocationChange: true
						});
					}
				} else {
					this.router.navigate(["dmv-review-cart"], {
						skipLocationChange: true
					});
				}
			}
		}
	}

	public removeConfirm() {
		this.openConfirmModel = false;
		const _this = this;
		this.dmvStoreService.registrationsInCart.dmvRegistrations = this.dmvStoreService.registrationsInCart.dmvRegistrations.filter(
			function(item, index) {
				return index !== _this.registrationNumber;
			}
		);

		if (
			this.dmvStoreService.registrationsInCart.dmvRegistrations.length === 0
		) {
			this.router.navigate(["dmv-search-results"], {
				skipLocationChange: true
			});
		} else if (
			this.dmvStoreService.registrationsInCart.dmvRegistrations.length > 0 &&
			this.registrationNumber ===
				this.dmvStoreService.registrationsInCart.dmvRegistrations.length
		) {
			this.registrationNumber = this.registrationNumber - 1;
		}
	}

	public continueConfirm() {
		this.openConfirmModel = false;
	}
	public callFindTagCatalogService() {
		this.isloading = true;
		this.dmvStoreService.findTagCatalog();
		this.dmvStoreService.tagCatalogData$.subscribe(tagCatalogResponse => {
			if (tagCatalogResponse) {
				this.changePlatePopUpOpen = true;
				this.isloading = false;
				this.hasTagCatalogData = true;
				this.cd.markForCheck();
			}
		});
	}
	public changePlate() {
		this.changePlatePopUpOpen = true;
		this.dmvCost = null;
		this.plateData = null;
		// if (!this.hasTagCatalogData) {
		// 	this.callFindTagCatalogService()
		// } else {
		// 	this.changePlatePopUpOpen = true;
		// 	this.isloading = false;
		// }
	}
	public changePlateYes(event) {
		this.isloading = false;
		const tag = event.tag;
		const registration = this.getFirstResistration();
		if (tag && tag.tagCode !== registration[0].currentTagCode) {
			this.dmvStoreService.registrationsInCart.dmvRegistrations[
				this.registrationNumber
			].isPlateChange = true;
		} else {
			this.dmvStoreService.registrationsInCart.dmvRegistrations[
				this.registrationNumber
			].isPlateChange = false;
		}

		this.updatePlate(event);
		this.updateNewDmvCostAndTagData(this.dmvCost, event.tag);
		this.updateDmvCost(this.dmvCost);
		this.changePlatePopUpOpen = false;
		this.dmvCost = null;
		this.plateData = null;
	}
	public getFirstResistration() {
		const _this = this;
		return this.registrationData.filter(function(item) {
			return (
				item.registrationID ===
				_this.dmvStoreService.registrationsInCart.dmvRegistrations[
					_this.registrationNumber
				].registration.registrationID
			);
		});
	}
	public updatePlate(event) {
		const tag = event.tag;
		this.dmvStoreService.registrationsInCart.dmvRegistrations[
			this.registrationNumber
		].registration.currentTagCode =
			tag.tagCode;
		this.dmvStoreService.registrationsInCart.dmvRegistrations[
			this.registrationNumber
		].imageCode =
			tag.imageCode;
		this.dmvStoreService.registrationsInCart.dmvRegistrations[
			this.registrationNumber
		].altText =
			tag.name;
	}
	public changePlateNo(event) {
		this.isloading = false;
		this.changePlatePopUpOpen = false;
		this.dmvCost = null;
		this.plateData = null;
	}
	public changePlateEvent(event) {
		AppUtil.log("CustomizeOrderComponent changePlateEvent ====>", event);
		this.isloading = false;
		if (
			event.tag &&
			event.tag.tagCode !==
				this.dmvStoreService.registrationsInCart.dmvRegistrations[
					this.registrationNumber
				].registration.currentTagCode
		) {
			const tag = event.tag;
			const registration = this.getFirstResistration();

			if (tag.tagCode === registration[0].currentTagCode) {
				this.changePlatePopUpOpen = false;
				this.dmvStoreService.registrationsInCart.dmvRegistrations[
					this.registrationNumber
				].isPlateChange = false;
				this.updatePlate(event);
			}

			this.updateTag(event.tag);
		} else {
			this.changePlateNo(event);
		}
	}
	public undoPlateChange() {
		this.dmvStoreService.registrationsInCart.dmvRegistrations[
			this.registrationNumber
		].isPlateChange = false;
		const registration = this.getFirstResistration();
		const tag = {
			tagCode: undefined
		};

		this.dmvStoreService.registrationsInCart.dmvRegistrations[
			this.registrationNumber
		].registration.currentTagCode =
			registration[0].currentTagCode;
		this.dmvStoreService.registrationsInCart.dmvRegistrations[
			this.registrationNumber
		].imageCode = this.dmvStoreService.registrationsInCart.dmvRegistrations[
			this.registrationNumber
		].oldImageCode;
		this.dmvStoreService.registrationsInCart.dmvRegistrations[
			this.registrationNumber
		].altText = this.dmvStoreService.registrationsInCart.dmvRegistrations[
			this.registrationNumber
		].oldAltText;

		this.updateTag(tag);
	}
	public updateTag(tag) {
		AppUtil.log("CustomizeOrderComponent tag ====>", tag);
		const dmvCostDataRequest: DmvCostDataRequest = new DmvCostDataRequest();
		const agencyID = this.agencyConfig.agencyDmvConfig.agencyID;
		const registration = this.getFirstResistration();
		if (tag.tagCode !== registration[0].currentTagCode && tag.tagCode) {
			dmvCostDataRequest.newTagCode = tag.tagCode;
		}

		const selectedOption = this.dmvStoreService.registrationsInCart
			.dmvRegistrations[this.registrationNumber];
		if (
			selectedOption &&
			selectedOption.registration &&
			selectedOption.registration.availableRenewalOptions &&
			selectedOption.registration.availableRenewalOptions.length
		) {
			dmvCostDataRequest.renewalOptionID = this.dmvStoreService.registrationsInCart.dmvRegistrations[
				this.registrationNumber
			].selectedRenewalOption;
		}

		const registrationID = this.dmvStoreService.registrationsInCart
			.dmvRegistrations[this.registrationNumber].registration.registrationID;
		this.dmvStoreService.registrationsInCart.dmvRegistrations[
			this.registrationNumber
		].annualFee =
			tag.annualFee;
		//this.plateChangeData = tag;
		this.isloading = true;
		this.findDmvCost(dmvCostDataRequest, agencyID, registrationID, tag, "tag");
	}
	public setDownIcon(event) {
		if (
			event.target &&
			event.target.offsetParent &&
			event.target.offsetParent.classList
		) {
			event.target.offsetParent.classList.remove("upArrow");
		}
	}
	public selectChangeByKey(event) {
		if (event.code === "Enter" || event.code === "Space") {
			this.selectChange(event);
		}
	}
	public selectChange(event) {
		if (
			event.target &&
			event.target.offsetParent &&
			event.target.offsetParent.classList
		) {
			if (!event.target.offsetParent.classList.contains("upArrow")) {
				event.target.offsetParent.classList.add("upArrow");
			} else {
				event.target.offsetParent.classList.remove("upArrow");
			}
		}
	}
	// public getImage(tagCode) {
	// 	let code: string = "";
	// 	this.tagImageCodeXref.forEach(xref => {
	// 		if (xref.tagCode === tagCode) {
	// 			code = xref.imageCode;
	// 		}
	// 	});
	// 	return code;
	// }
	public closeOverlay() {
		this.changePlatePopUpOpen = false;
	}
}
